import React, { useEffect } from "react";
import NoItemFound from "../../Components/SiteComponants/NoItemFound";
import { useState } from "react";
import ProfileLeft from "../../Components/PorfileSections/ProfileLeft";
import ProfileRight from "../../Components/PorfileSections/ProfileRight";
import { useContext } from "react";
import { UserContext } from "../../App";
import { TitleSetup } from "../../Datas/Functions/titleSetup";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import { useAuthContext } from "../../Contexts/AuthContext";
import { useParams } from "react-router-dom";
import { alluser } from "../../Datas/ProfileDatas/alluser";
import { notify } from "../../Datas/Functions/toast";
import { useSiteData } from "../../Contexts/SiteContext";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";

const Profile = (meta) => {
  // setting up title of this page
  TitleSetup({...meta});
  //********** */
  const { user, setUser } = useAuthContext();
  const { userList, setUserList } = useSiteData();
  const [showProfile, setShowProfile] = useState(null);

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      const showprof = userList.find((prof) => prof.id == id);

      setShowProfile(showprof);
    } else {
      // const getUser = JSON.parse(localStorage.getItem("user")) || null
      setShowProfile(user);
    }
  }, [user]);
  return (
    <div className="container mx-auto p-4 my-4">
      <SectionHeader heading={"Profile"} />
      <BreadCrumbs texts={["Dashboard", "Profile Section"]} />
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ">
        {showProfile ? (
          <>
            <ProfileLeft user={showProfile} />
            <ProfileRight user={showProfile} />
          </>
        ) : (
          <NoItemFound msg={"No User Found"} />
        )}
      </div>
    </div>
  );
};

export default Profile;
